import {MyTeamsFilters} from './myTeamsFilterDomain.util';

export function buildMyTeamsFiltersPayload(filters: MyTeamsFilters) {
  const {
    frontlineOnly = false,
    rank = [],
    fibc = 'Any',
    period,
    periodDefaultValue,
    frontlineAction,
  } = filters;

  const hasRanks = rank.length > 0;
  const filterPayload: any = {};
  const frontlineFilterAction =
    frontlineAction || (frontlineOnly ? 'Frontline_add' : '');

  // Include frontline if applied
  if (frontlineFilterAction) {
    filterPayload.filter_type = frontlineFilterAction;
    filterPayload.filter_selected = 'NA';
  }

  // Include ranks if applied
  if (hasRanks) {
    filterPayload.filter_type = filterPayload.filter_type
      ? `${filterPayload.filter_type}|ranks`
      : 'ranks';
    filterPayload.filter_selected = filterPayload.filter_selected
      ? `${filterPayload.filter_selected}|${rank.join(',')}`
      : rank.join(',');
  }

  // Include FIBC/New Coaches if applied
  const hasRadioSelection =
    fibc !== 'Any' || period !== periodDefaultValue || rank.length > 0;

  if (hasRadioSelection) {
    filterPayload.filter_type2 = 'FIBC|New Coaches';
    filterPayload.filter_selected2 = `${fibc}|${period}`;
  }
  return filterPayload;
}
